import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import type { Package } from '@/integrations/revenuecat/types';

import {
  subscribe,
  type SubscribeResult,
  type SubscriptionError,
} from './subscribe';

export type UseSubscribeOptions = Omit<
  UseMutationOptions<SubscribeResult, SubscriptionError, Package>,
  'mutationFn'
>;

export function useSubscribe(options: UseSubscribeOptions = {}) {
  return useMutation({
    mutationFn: subscribe,
    ...options,
  });
}
